import styled from 'styled-components';

export const Container = styled.div``;

export const Div = styled.div``;

export const ButtonCopy = styled.button`
  width: 20px;
  height: 20px;
  background: none;
  border: none;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const Grid = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const GridButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--s2);
  flex-wrap: wrap;
`;
